module.exports = __webpack_public_path__ + "static/media/neutral.f657f6c4.png";